import { QueryClient } from "@tanstack/react-query";

// Catalog data is effectively static between rebuilds, so cache aggressively and
// don't refetch on focus — returning to the catalog from a game should be instant.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
